import { render } from "./BusinessDetails.vue?vue&type=template&id=64606e2a"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"

import "./BusinessDetails.vue?vue&type=style&index=0&id=64606e2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__